export const NOT_STARTED = 'NOT_STARTED';
export const STARTED = 'STARTED';
export const FINISHED = 'FINISHED';
export const REFRESH = 'REFRESH';
export const REFRESH_ERROR = 'REFRESH_ERROR';
export const ERROR = 'ERROR';

export type FetchStatus =
  | typeof NOT_STARTED
  | typeof STARTED
  | typeof FINISHED
  | typeof REFRESH
  | typeof REFRESH_ERROR
  | typeof ERROR;
